import {CbTableBodyDirective} from './table-ele/table-body.directive';
import {CbTableRowDirective} from './table-ele/table-row.directive';
import {CbTableHeadDirective} from './table-ele/table-head.directive';
import {CbTableStickyColDirective} from './table-ele/sticky-col.directive';
import {TableComponent} from './table/table.component';
import {CbTableDirective} from './table-ele/table.directive';
import {TdIconComponent} from './table-cells/icon/icon.component';
import {TdCheckboxComponent} from './table-cells/checkbox/checkbox.component';
import {TdCommaSeperatedListComponent} from './table-cells/comma-seperated-list/comma-seperated-list.component';
import {TdDateComponent} from './table-cells/date/date.component';
import {TdEnumComponent} from './table-cells/enum/enum.component';
import {TdTextComponent} from './table-cells/text/text.component';

export const CB_TABLE_EXPORTS = [
    TableComponent,
    CbTableHeadDirective,
    CbTableBodyDirective,
    CbTableRowDirective,
    CbTableStickyColDirective,
    CbTableDirective,
    TdIconComponent,
    TdCheckboxComponent,
    TdCommaSeperatedListComponent,
    TdDateComponent,
    TdTextComponent,
    TdEnumComponent
];
